const syncUploadBaseUrl = process.env.VUE_APP_SYNCUPLOAD_URL;

export default {
  product: 'mdict',
  keyId: 'tongchuan-server',
  signSecretKey: 'W0Lepryz72yOoA#J',
  whiteCodeList: [
    `${syncUploadBaseUrl}/file/list`,
    `${syncUploadBaseUrl}/file/delete`,
    `${syncUploadBaseUrl}/file/rename`,
    `${syncUploadBaseUrl}/user/info`,
  ],
};
